define('controller/step/DetailsStep',['require','lib/controller/booking/BaseStep','view/controller/booking/details/DetailsView','model/BookingServerRequestModel','lib/plugin/PluginBroker','model/LicenseModel','lib/terms/ClientTermsController','model/TimeCorrectionModel'],function (require) {

	var BaseStep = require('lib/controller/booking/BaseStep');
	var DetailsView = require('view/controller/booking/details/DetailsView');
	var BookingServerRequestModel = require('model/BookingServerRequestModel');
    var PluginBroker = require('lib/plugin/PluginBroker');
    var LicenseModel = require('model/LicenseModel');
    var ClientTermsController = require('lib/terms/ClientTermsController');
	var TimeCorrectionModel = require('model/TimeCorrectionModel');

	/**
	 * Client details step
	 * 
	 * @class DetailsStep
	 */
	return BaseStep.extend({
		
		_step: 'details',
        _isValidStep: false,
		_licenseModel: null,
		_clientModel: null,
		_timeValidateModel: null,
		_termsController: null,
		bookingModels: [],

		initialize: function () {
			BaseStep.prototype.initialize.call(this);

            this._timeValidateModel = this.getOption('timeValidateModel');

			this._initLicenseModel();
			this._initClintInfoModel();
			this.listenTo(this._bookingModel, 'change:service', this.isBookingsHasDepositService);

            this._termsController = ClientTermsController.getInstance({
                'client': this._clientModel
            });
		},

        /**
         * Start processing step, calling before show, refresh view for each step
         */
        start: function () {
            this._bookingModel.set('dates', this._timeValidateModel.get('dates'));
			this._bookingModel.validationError = null;
        },

		/**
		 * Inits license model
		 *
		 * @private
		 */
		_initLicenseModel: function () {
			var model = LicenseModel.extend({
				url: '/license'
			});
			this._licenseModel = new model();
		},

		/**
		 * Inits client info model when client login plugin is turned off
		 *
		 * @private
		 */
		_initClintInfoModel: function () {
			this._clientModel = this.getOption('clientModel');
			if (this._clientModel) {
				this.listenTo(this._clientModel, 'sync', this._updateClientInfo);
				this._updateClientInfo();
			}
		},

		/**
		 * Returns details step layout
		 * 
		 * @return DetailsView
         */
		getView: function () {
			this.bookingModels.push(this._bookingModel);
			this._bookingModel.set('with_deposit', this.isBookingsHasDepositService());

			var clientTimeZone = this.getOption('clientTimeZone');

			if(this._bookingModel.get('wl')){
				clientTimeZone = this.getOption('companyTimeZone'); //do not change date in view if its waiting list
			}

			var timeCorrectionModel = new TimeCorrectionModel();
			timeCorrectionModel.fetch({
				data: {
					client_time_zone: clientTimeZone.id,
					date_time: this._bookingModel.get('start_date') + ' ' + this._bookingModel.get('start_time'),
					dates: this._bookingModel.get('dates'),
					time: this._bookingModel.get('start_time'),
				}
			});

			var view = new DetailsView({
                model: this._bookingModel,
                licenseModel: this._licenseModel,
                timeValidateModel: this._timeValidateModel,
				clientTimeZone: clientTimeZone,
				clientModel: this._clientModel,
				timeCorrectionModel: timeCorrectionModel
            });

            this._termsController.getModel().fetch();
			this.listenTo(view, 'render', _.bind(function () {
                view.showTermsAndConditions(this._termsController.getView());
			}, this));

            this.listenTo(view, 'submit', this.saveBooking);

            return view;
		},

		/**
		 * We store booking through BookingServerRequestModel, 
		 * because the result can contain multiple bookings.
		 * (e.g. group bookings, recurring bookings, etc.)
		 */
		saveBooking: function () {
			this._bookingModel.set('terms', this._termsController.getModel().getAcceptedTerms(), {
				silent: true
			});

			// var serverRequestModel = BookingServerRequestModel.createWithCurrentBooking(this._bookingModel);
			var serverRequestModel = new BookingServerRequestModel({
				'current_booking': this._bookingModel
			});

            PluginBroker.getInstance().perform('beforeSaveBooking', [serverRequestModel]);

			delete this._bookingModel.validationError;
			this.listenTo(serverRequestModel, 'invalid', function () {
				this._bookingModel.validationError = serverRequestModel.validationError;
				this._bookingModel.trigger('invalid');
			});

			var pluginValidate = PluginBroker.getInstance().validate();
			var termsValidate = this._termsController.validate();

            if (pluginValidate && termsValidate) {
                serverRequestModel.save(null, {
                    success: _.bind(this.onSave, this)
                });
            } else {
				var validationErrors = !pluginValidate && PluginBroker.getInstance().getValidationErrors();

				if (validationErrors) {
					this._bookingModel.validationError = _.extend(this._bookingModel.validationError || {}, validationErrors);
				}

                this._bookingModel.trigger('invalid');
			}

            PluginBroker.getInstance().perform('onSaveBooking', [serverRequestModel]);
		},

		/**
		 * Handle success booking saving. Add stored bookings to bookings collection.
		 * 
		 * @param Object data
		 */
		onSave: function (data) {
            PluginBroker.getInstance().perform('afterSaveBooking', [data]);

            this.bookingModels = data.get('bookings').models;

            if (data.get('confirm')) {
                this.finishBooking(data);

				if (this._clientModel && !Config.getInstance().getPluginStatus('client_login')) {
					this._clientModel.fetch();
				} else {
                    this._termsController.getModel().fetch();
				}

				this.bookingModels = [];
            }
		},

        /**
         * Perform redirects after save booking
         *
         * @param BookingServerRequestModel data
         */
        finishBooking: function (requestModel) {
            this._isValidStep = true;

            PluginBroker.getInstance().perform('finishBooking', [requestModel]);
            //this.done();
			this._stepManager.bookingDone(requestModel);

            this._isValidStep = false;
        },

        /**
         * Returns false at any time. use bookingDone event to move to next step
         *
         * @return Boolean
         */
        isValid: function () {
            return false;
        },

		/**
		 * Updates client information
		 *
		 * @private
		 */
		_updateClientInfo: function () {
			//console.log(this._clientModel.get('id'));
			if (this._clientModel.get('id')) {
                this._bookingModel.set({
                    'client_name': this._clientModel.get('name'),
                    'client_email': this._clientModel.get('email'),
                    'client_phone': this._clientModel.get('phone')
                });
            } else {
				this._bookingModel.set({ //clear old data
					'client_name': null,
					'client_email': null,
					'client_phone': null
				});
                this._bookingModel.updatePredefinedClientInfo();
            }
		},

		/**
		 * Is booking has deposit service
		 *
		 * @returns {boolean}
		 */
		isBookingsHasDepositService: function() {
			var isBookingsHasDepositService = false;
			this.bookingModels.forEach(function(model) {
				if (model.get('service') && model.get('service').deposit_is_enabled === '1') {
					isBookingsHasDepositService = true;
				}
			});

			return isBookingsHasDepositService;
		}
		
	});
	
});
